import { Link } from "react-router-dom";
import styles from "./ProductBreadcrumbs.module.css";
import { getLensSeriesKey } from "../utils/lens";

const ProductBreadcrumbs = ({ singleProduct, returnTo }) => {
  const libraryHref = "/";
  const firstCrumbHref = returnTo || libraryHref;
  const isReturnToResults = Boolean(returnTo);
  const mobileBackLabel = isReturnToResults ? "Back to results" : "Back to library";

  const cameraLabel = [singleProduct?.camera?.brand, singleProduct?.camera?.model_name]
    .filter(Boolean)
    .join(" ");

  const cameraHref = singleProduct?.camera?.id
    ? `${libraryHref}?camera=${singleProduct.camera.id}`
    : libraryHref;

  const lensBrand = singleProduct?.lens?.brand || "";
  const lensSeries = singleProduct?.lens?.series || "";
  const lensSeriesKey = getLensSeriesKey(singleProduct?.lens);

  const lensBrandHref = lensBrand
    ? `${libraryHref}?lens_brand=${encodeURIComponent(lensBrand.toLowerCase())}`
    : libraryHref;
  const lensSeriesHref = lensSeriesKey
    ? `${libraryHref}?lens_series=${encodeURIComponent(lensSeriesKey)}`
    : libraryHref;

  return (
    <nav className={styles.root} aria-label="Breadcrumb">
      <ol className={styles.list}>
        <li className={styles.item}>
          <Link
            to={firstCrumbHref}
            className={`${styles.link} ${styles.backLink}`}
            aria-label={isReturnToResults ? "Back to library results" : "Open library"}
          >
            {isReturnToResults && <span className={`${styles.backArrow} ${styles.backArrowDesktop}`} aria-hidden="true">←</span>}
            <span className={`${styles.backArrow} ${styles.backArrowMobile}`} aria-hidden="true">←</span>
            <span className={styles.backLabelDesktop}>
              {isReturnToResults ? "Back to results" : "Library"}
            </span>
            <span className={styles.backLabelMobile}>
              {mobileBackLabel}
            </span>
          </Link>
        </li>

        {cameraLabel && (
          <>
            <li className={`${styles.separator} ${styles.desktopOnly}`} aria-hidden="true">/</li>
            <li className={`${styles.item} ${styles.desktopOnly}`}>
              <Link to={cameraHref} className={styles.link}>
                {cameraLabel}
              </Link>
            </li>
          </>
        )}

        {lensBrand && (
          <>
            <li className={`${styles.separator} ${styles.desktopOnly}`} aria-hidden="true">/</li>
            <li className={`${styles.item} ${styles.desktopOnly}`}>
              <Link to={lensBrandHref} className={styles.link}>
                {lensBrand}
              </Link>
            </li>
          </>
        )}

        {lensSeries && (
          <>
            <li className={`${styles.separator} ${styles.desktopOnly}`} aria-hidden="true">/</li>
            <li className={`${styles.item} ${styles.desktopOnly}`}>
              <Link to={lensSeriesHref} className={styles.link}>
                {lensSeries}
              </Link>
            </li>
          </>
        )}
      </ol>
    </nav>
  );
};

export default ProductBreadcrumbs;
